export enum Language {
  RU = 'ru',
  EN = 'en',
}
